import React, { useState } from 'react';

const AdminParent = ({
    onDashboard,
    onCourseManagement,
    onChapterManagement,
    onQuestionBank,
    onStudentDirectory,
    onParentDirectory,
    onRevenue,
    onLogout
}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    return (
        <>
            <style>
                {`
                .material-symbols-outlined {
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
                    vertical-align: middle;
                    display: inline-block;
                    line-height: 1;
                    text-transform: none;
                    letter-spacing: normal;
                    word-wrap: normal;
                    white-space: nowrap;
                    direction: ltr;
                }
                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: transparent;
                }
                ::-webkit-scrollbar-thumb {
                    background: rgba(203, 213, 225, 0.5);
                    border-radius: 10px;
                }
                .dark ::-webkit-scrollbar-thumb {
                    background: rgba(51, 65, 85, 0.5);
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: rgba(148, 163, 184, 0.8);
                }
                .dark ::-webkit-scrollbar-thumb:hover {
                    background: rgba(71, 85, 105, 0.8);
                }
                scrollbar-width: thin;
                scrollbar-color: rgba(203, 213, 225, 0.5) transparent;
                `}
            </style>

            <div className={`fixed inset-0 flex overflow-hidden font-sans antialiased ${isDarkMode ? 'dark bg-[#0F172A] text-slate-100' : 'bg-[#F8FAFC] text-slate-900'}`}>
                {/* Sidebar */}
                <aside className="w-64 bg-[#131C2E] text-slate-300 flex-shrink-0 flex flex-col border-r border-slate-800 hidden lg:flex h-full">
                    <div className="p-6 flex items-center gap-3 shrink-0">
                        <div className="w-10 h-10 bg-[#00A669] rounded-lg flex items-center justify-center text-white font-bold text-xl uppercase tracking-tighter shadow-lg shadow-emerald-500/20">H</div>
                        <div>
                            <h1 className="text-white font-bold leading-tight">Master Admin</h1>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold text-nowrap">System Management</p>
                        </div>
                    </div>

                    <nav className="flex-1 px-4 space-y-1 mt-4 overflow-y-auto custom-scrollbar">
                        <button
                            onClick={onDashboard}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">dashboard</span>
                            <span className="font-medium group-hover:text-white transition-colors">Dashboard Overview</span>
                        </button>

                        <div className="pt-4 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Core Content</div>
                        <button
                            onClick={onCourseManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">auto_stories</span>
                            <span className="font-medium group-hover:text-white transition-colors">Course Management</span>
                        </button>
                        <button
                            onClick={onChapterManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">account_tree</span>
                            <span className="font-medium group-hover:text-white transition-colors">Chapter Management</span>
                        </button>
                        <button
                            onClick={onQuestionBank}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">quiz</span>
                            <span className="font-medium group-hover:text-white transition-colors">Question Bank</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Directories</div>
                        <button
                            onClick={onStudentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">group</span>
                            <span className="font-medium group-hover:text-white transition-colors">Student Directory</span>
                        </button>
                        <button
                            onClick={onParentDirectory}
                            className="w-full bg-[#00A669] text-white flex items-center gap-3 px-4 py-3 rounded-xl transition-all shadow-md shadow-emerald-500/20 text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">family_restroom</span>
                            <span className="font-medium">Parent Directory</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Reports</div>
                        <button
                            onClick={onRevenue}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">monitoring</span>
                            <span className="font-medium group-hover:text-white transition-colors">Revenue/Analytics</span>
                        </button>




                    </nav>

                    <div className="p-4 mt-auto border-t border-slate-800 shrink-0">
                        <button
                            onClick={onLogout}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-400 hover:bg-rose-500/10 transition-all group"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">logout</span>
                            <span className="font-medium group-hover:translate-x-1 transition-transform">Sign Out</span>
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-white dark:bg-[#1E293B] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-8 sticky top-0 z-20 shrink-0 shadow-sm">
                        <div className="flex-1 max-w-xl">
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-[20px]">search</span>
                                <input
                                    className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg pl-10 pr-4 py-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-sm outline-none text-slate-700 dark:text-slate-200"
                                    placeholder="Search parents, emails or mobile numbers..."
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-6 ml-6">
                            <button className="relative text-slate-500 dark:text-slate-400 hover:text-[#00A669] transition-colors flex items-center">
                                <span className="material-symbols-outlined">notifications</span>
                                <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border-2 border-white dark:border-[#1E293B]"></span>
                            </button>
                            <div className="h-8 w-[1px] bg-slate-200 dark:bg-slate-700"></div>
                            <div className="flex items-center gap-3">
                                <div className="text-right hidden sm:block">
                                    <p className="text-sm font-semibold dark:text-white">Admin Profile</p>
                                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-tight">Super Administrator</p>
                                </div>
                                <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 overflow-hidden shadow-sm">
                                    <img alt="Admin Avatar" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAnLw6N7G6x01o2M1q10wF5Nn5u0q5K0M1sIn7S8PzC5m5H5K0L1sIn7S8PzC5m5H5" />
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Scrollable Content */}
                    <main className="flex-1 overflow-y-auto p-8 space-y-6 bg-background-light dark:bg-[#0F172A] pb-24">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                            <div>
                                <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">Parent Directory</h2>
                                <p className="text-slate-500 dark:text-slate-400 mt-1">Oversee parent accounts, linked student profiles, and subscription lifecycles.</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <button className="px-5 py-2.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-[#1E293B] text-slate-600 dark:text-slate-300 font-semibold text-sm hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center gap-2 shadow-sm">
                                    <span className="material-symbols-outlined text-[20px]">file_download</span>
                                    CSV Export
                                </button>
                                <button className="px-5 py-2.5 rounded-lg bg-[#00A669] text-white font-semibold text-sm hover:bg-opacity-90 shadow-lg shadow-emerald-500/20 transition-all flex items-center gap-2">
                                    <span className="material-symbols-outlined text-[20px]">person_add</span>
                                    Manual Enrolment
                                </button>
                            </div>
                        </div>

                        {/* Summary Stats */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            {[
                                { label: 'Total Parents', value: '842', trend: '+12.5%', color: 'blue', icon: 'groups' },
                                { label: 'Premium Users', value: '312', trend: '+8.2%', color: 'emerald', icon: 'workspace_premium' },
                                { label: 'Standard Users', value: '530', trend: '-2.1%', color: 'amber', icon: 'person' },
                                { label: 'Revenue/Month', value: '$12,450', trend: '+15.3%', color: 'purple', icon: 'payments' },
                            ].map((stat, i) => (
                                <div key={i} className="bg-white dark:bg-[#1E293B] p-5 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm">
                                    <div className="flex items-center justify-between mb-3">
                                        <div className={`p-2 rounded-lg bg-${stat.color}-50 dark:bg-${stat.color}-500/10 text-${stat.color}-600 dark:text-${stat.color}-400`}>
                                            <span className="material-symbols-outlined text-[20px]">{stat.icon}</span>
                                        </div>
                                        <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${stat.trend.startsWith('+') ? 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400' : 'bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-400'}`}>{stat.trend}</span>
                                    </div>
                                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">{stat.label}</p>
                                    <p className="text-2xl font-bold text-slate-900 dark:text-white mt-1">{stat.value}</p>
                                </div>
                            ))}
                        </div>

                        {/* Table Controls */}
                        <div className="flex flex-wrap items-center justify-between gap-4">
                            <div className="flex items-center gap-2">
                                <button className="px-4 py-2 bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-800 rounded-lg text-sm font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 transition-all flex items-center gap-2">
                                    <span className="material-symbols-outlined text-[18px]">filter_list</span>
                                    Filter by Subscription
                                </button>
                                <button className="px-4 py-2 bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-800 rounded-lg text-sm font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 transition-all">
                                    Active Only
                                </button>
                            </div>
                            <p className="text-sm text-slate-500 italic">Showing directory of all verified primary contacts</p>
                        </div>

                        {/* Parent Table */}
                        <div className="bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm overflow-hidden border-b-0">
                            <div className="overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[900px]">
                                    <thead>
                                        <tr className="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-200 dark:border-slate-800">
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Parent Info</th>
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Subscription</th>
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Linked Children</th>
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Wallet Balance</th>
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Join Date</th>
                                            <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                        {[
                                            { name: 'Robert Johnson', status: 'Premium Plus', children: ['Alex Johnson', 'Lily Johnson'], bal: '$420.00', date: 'Oct 12, 2023', initial: 'RJ', color: 'bg-emerald-500' },
                                            { name: 'Elena Williams', status: 'Standard', children: ['Sarah Williams'], bal: '$0.00', date: 'Jan 04, 2024', initial: 'EW', color: 'bg-blue-500' },
                                            { name: 'Liang Chen', status: 'Standard', children: ['Michael Chen'], bal: '$12.50', date: 'Nov 20, 2023', initial: 'LC', color: 'bg-amber-500' },
                                            { name: 'Mark Davis', status: 'Premium', children: ['Emma Davis'], bal: '$85.00', date: 'Feb 15, 2024', initial: 'MD', color: 'bg-purple-500' },
                                            { name: 'Sophie Miller', status: 'Premium Plus', children: ['Jack Miller', 'Leo Miller'], bal: '$150.75', date: 'Mar 02, 2024', initial: 'SM', color: 'bg-rose-500' },
                                        ].map((parent, i) => (
                                            <tr key={i} className="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors group">
                                                <td className="p-4">
                                                    <div className="flex items-center gap-3">
                                                        <div className={`w-10 h-10 rounded-xl ${parent.color} flex items-center justify-center text-white font-bold text-sm shadow-sm`}>{parent.initial}</div>
                                                        <div>
                                                            <p className="text-sm font-bold text-slate-900 dark:text-white group-hover:text-[#00A669] transition-colors">{parent.name}</p>
                                                            <p className="text-xs text-slate-500">user_{parent.initial.toLowerCase()}@provider.com</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="p-4">
                                                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold ${parent.status.includes('Premium') ? 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400' : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400'
                                                        }`}>
                                                        <span className="material-symbols-outlined text-[14px]">{parent.status.includes('Premium') ? 'workspace_premium' : 'person'}</span>
                                                        {parent.status}
                                                    </span>
                                                </td>
                                                <td className="p-4">
                                                    <div className="flex flex-wrap gap-1.5">
                                                        {parent.children.map((child, ci) => (
                                                            <span
                                                                onClick={onStudentDirectory}
                                                                key={ci}
                                                                className="px-2 py-0.5 bg-slate-100 dark:bg-slate-800 text-[10px] font-bold text-slate-600 dark:text-slate-400 rounded-md hover:bg-[#00A669] hover:text-white transition-all cursor-pointer"
                                                            >
                                                                {child}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </td>
                                                <td className="p-4">
                                                    <p className="text-sm font-bold text-slate-900 dark:text-white">{parent.bal}</p>
                                                    <p className="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">Auto-refill On</p>
                                                </td>
                                                <td className="p-4 text-sm text-slate-600 dark:text-slate-400">{parent.date}</td>
                                                <td className="p-4 text-right">
                                                    <div className="flex items-center justify-end gap-2">
                                                        <button className="p-2 text-slate-400 hover:text-[#00A669] transition-colors"><span className="material-symbols-outlined text-[20px]">mail</span></button>
                                                        <button className="p-2 text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"><span className="material-symbols-outlined text-[20px]">manage_accounts</span></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Footer */}
                        <footer className="py-8 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-400 text-[10px] font-bold uppercase tracking-widest gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-6 h-6 bg-[#00A669] rounded flex items-center justify-center text-white text-[10px] font-bold">H</div>
                                <span>© 2024 Himigo Platform - Master Admin Console</span>
                            </div>
                        </footer>
                    </main>
                </div>

                {/* Dark Mode Toggle Float */}
                <button
                    onClick={toggleDarkMode}
                    className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-200/50 dark:shadow-none flex items-center justify-center text-slate-600 dark:text-slate-300 z-[60] hover:scale-110 active:scale-95 transition-all"
                >
                    <span className="material-symbols-outlined">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
                </button>
            </div>
        </>
    );
};

export default AdminParent;
